import React, { ReactNode } from 'react';
import { Alignment } from './Flex';

// align-self values
export { Alignment };

interface IFlexChild {
  align?: Alignment;
  children: ReactNode;
  grow?: number;
  order?: number;
  shrink?: number;
  type?: 'div' | 'label' | 'section' | 'span';
}

const FlexChild = ({
  children,
  type: Wrapper = 'div',
  align,
  grow,
  shrink,
  order,
}: IFlexChild) => (
  <Wrapper
    children={children}
    style={{
      flexGrow: grow,
      flexShrink: shrink,
      alignSelf: align,
      order,
    }}
  />
);

export default FlexChild;
